// Base URL configuration
export const BASE_URL = 'https://app.digitalworld.pk';

export const PERMISSIONS = [
  { id: 'create', name: 'Create' },
  { id: 'read', name: 'Read' },
  { id: 'update', name: 'Update' },
  { id: 'delete', name: 'Delete' },
];
